<template>
  <div class="content doctorInformation"  v-loading.fullscreen.lock="fullscreenLoading">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6">
          <div class="search-area-div">所属企业</div>
          <el-select class="ipt-sty" size="mini" v-model="searchData.tenantGuid" filterable placeholder="请选择" clearable
            @change="companyChange">
            <el-option v-for="item in companyList" :key="item.sendTenantGuid" :label="item.sendTenantName"
              :value="item.sendTenantGuid">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">居间人姓名</div>
          <el-input class="ipt-sty" size="mini" v-model="searchData.clientName" placeholder="请输入" clearable></el-input>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">负责客户</div>
          <el-input class="ipt-sty" size="mini" v-model="searchData.customerName" placeholder="请输入" clearable></el-input>
        </el-col>
        <el-col :span="6" class="search-btn-box">
          <el-button size="mini" type="expand" @click="showMore = !showMore"><i
              :class="showMore ? 'el-icon-arrow-up mr5' : 'el-icon-arrow-down mr5'"></i>{{
                showMore?'收起筛选': '更多筛选'
              }}</el-button>
          <el-button size="mini" type="info" @click="getList(1)">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch">清空</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="24" class="mt15" v-if="showMore">
        <el-col :span="6">
          <div class="search-area-div">代理产品</div>
          <el-select class="ipt-sty" size="mini" ref="mySelected" style="width:100%;" v-model="searchData.productName"
            v-loading="productSelectLoading" :remote-method="getProduct" filterable remote placeholder="请输入关键词"
            @focus="selectFocus">
            <el-option v-for="item in productList" :key="item.guid" :label="item.goodsName" :value="item.goodsName">
            </el-option>
          </el-select>
          <!-- <el-input v-model="searchData.productName" placeholder="请输入" clearable></el-input> -->
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">覆盖区域</div>
          <el-cascader class="ipt-sty" size="mini" ref="cascaderFirst" :options="options" collapse-tags clearable
            v-model="cityList" :props="{ checkStrictly: false, value: 'code', }" @change="incres" style="width:100%;"
            placeholder="请选择">
          </el-cascader>
          <!-- <el-input v-model="searchData.coverageArea" placeholder="请输入" clearamble></el-input> -->
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">指派人手机</div>
          <el-input style="width: 180px;" size="mini" v-model="searchData.createUserMobile" placeholder="请输入"
            clearable></el-input>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">业务指派人</div>
          <el-input style="width: 180px;" size="mini" v-model="searchData.createUserName" placeholder="请输入"
            clearable></el-input>
        </el-col>
        
      </el-row>
      <el-row :gutter="24" class="mt15" v-show="showMore">
        <el-col :span="6">
          <div class="search-area-div">启用状态</div>
          <el-select size="mini" class="ipt-sty" v-model="searchData.bizStateList" placeholder="请选择" multiple filterable>
            <el-option v-for="item in bizStateOp" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <!-- <el-row :gutter="24" class="mt15" v-show="showMore">
        <el-col :span="6">
          <div class="search-area-div">更新时间</div>
          <el-date-picker
            size="mini"
            v-model="updateTime"
            type="daterange"
            class="ipt-sty"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">更新人</div>
          <el-input
            size="mini"
            v-model="searchData.updateName"
            class="ipt-sty"
            placeholder="请输入数据更新人姓名"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">审核状态</div>
          <el-select size="mini" class="ipt-sty" v-model="searchData.approveState" placeholder="请选择" filterable>
            <el-option v-for="item in approveStateOp" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">审核时间</div>
          <el-date-picker
            size="mini"
            v-model="approveTime"
            type="daterange"
            class="ipt-sty"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-col>
        
      </el-row> -->
    </div>
    <div class="back-color-fff content-main-box" :style="'height:' + contentMainHeight + 'px;'">
      <div class="button-area p16">
        <el-button v-if="getBtnPermissionsByName('添加资料')" icon="el-icon-plus" size="mini" type="info" @click="addContent">添加资料</el-button>
        <el-button v-if="getBtnPermissionsByName('批量导出')" size="mini" type="info" @click="report">批量导出</el-button>
        <el-button v-if="getBtnPermissionsByName('批量导入')" size="mini" type="info" @click="batchImport">批量导入</el-button>
        <el-button v-if="getBtnPermissionsByName('批量启用')" size="mini"  @click="batchChangeState('Y')">批量启用</el-button>
        <el-button v-if="getBtnPermissionsByName('批量停用')" size="mini"  @click="batchChangeState('S')">批量停用</el-button>  
        <el-button v-if="getBtnPermissionsByName('批量删除')" size="mini"  @click="getDeleteData(1, '')">批量删除</el-button>
      </div>
      <el-table ref="multipleTable" :data="tableData" style="width: 100%" v-loading="tableLoading" row-key="guid"
        @selection-change="handleSelectionChange" :height="tableHeight" stripe border >
        <el-table-column type="selection" width="40" header-align="center" align="center"></el-table-column>
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (searchData.pageIndex - 1) * searchData.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="tenantName" min-width="240" label="所属公司" header-align="center" align="left"
          show-overflow-tooltip></el-table-column>
        <el-table-column prop="clientName" width="96" label="姓名" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.clientName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="mobileNo" width="120" label="联系方式" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.mobileNo || '-' }}</template>
        </el-table-column>
        <el-table-column prop="sex" width="80" label="性别" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.sex == 'M' ? '男' : scope.row.sex == 'F' ? '女' : '-' }}</template>
        </el-table-column>
        <el-table-column prop="sex" width="80" label="客户类型" header-align="center" align="left">
          <template slot-scope="scope">{{ !scope.row.chargeCustomerList ? '-' :
            scope.row.chargeCustomerList[0].customerType == '1' ? '医院' : '商业公司' }}</template>
        </el-table-column>
        <el-table-column prop="chargeCustomerList" width="140" label="负责客户" header-align="center" align="left"
          show-overflow-tooltip>
          <template slot-scope="scope">{{ getChargeCustomerName(scope.row.chargeCustomerList) }}</template>
        </el-table-column>
        <el-table-column prop="agentProductList" width="140" label="代理产品" header-align="center" align="left"
          show-overflow-tooltip>
          <template slot-scope="scope">{{ getChargeCustomerName(scope.row.agentProductList, 1) }}</template>
        </el-table-column>
        <el-table-column prop="businessAbility" width="96" label="业务员能力" header-align="center" align="left">
          <template slot-scope="scope">{{ getFieldName('businessAbility', scope.row.businessAbility) }}</template>
        </el-table-column>
        <el-table-column prop="performanceIndicator" label="业绩指标(元)" header-align="center" align="right" width="110">
          <template slot-scope="scope">{{ scope.row.performanceIndicator | numFmt | numDigit }}</template>
        </el-table-column>
        <el-table-column prop="adeptType" width="140" label="擅长品类" header-align="center" align="left"
          show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.adeptType || '-' }}</template>
        </el-table-column>
        <el-table-column prop="expertDomainList" width="140" label="专长领域" header-align="center" align="left"
          show-overflow-tooltip>
          <template slot-scope="scope">{{ getExpertDomainName(scope.row.expertDomainList) }}</template>
        </el-table-column>
        <el-table-column prop="coverageAreaList" label="覆盖区域" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ getChargeCustomerName(scope.row.coverageAreaList, 2) }}</template>
        </el-table-column>
        <!-- <el-table-column
          prop="updateName"
          label="更新人"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="70"
        >
          <template slot-scope="scope">{{ scope.row.updateName || '-' }}</template>
        </el-table-column> -->
        <!-- <el-table-column width="160" prop="updateTime" label="更新时间" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.updateTime | getTimeDate }}</template>
        </el-table-column> -->
        <!-- <el-table-column width="160" prop="approveTime" label="审核时间" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.approveTime | getTimeDate }}</template>
        </el-table-column> -->
        <!-- <el-table-column
          prop="approveState"
          width="96"
          label="审核状态"
          show-overflow-tooltip
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag size="mini" v-if="scope.row.approveState" :type="type[scope.row.approveState]">{{
              approveStateObj[scope.row.approveState] || '-'
            }}</el-tag>
            <span v-else>{{ '-' }}</span>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="bizState"
          width="96"
          label="启用状态"
          show-overflow-tooltip
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag size="mini" v-if="scope.row.bizState" :type="type[scope.row.bizState]">{{
              bizStateObj[scope.row.bizState] || '-'
            }}</el-tag>
            <span v-else>{{ '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="contacts" label="指派人手机号" header-align="center" align="left" width="130">
          <template slot-scope="scope">{{ scope.row.createUserMobile || '-' }}</template>
        </el-table-column>
        <el-table-column prop="contactTel" label="业务指派人" header-align="center" align="left" width="120">
          <template slot-scope="scope">{{ scope.row.createUserName || '-' }}</template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center" width="130" fixed="right">
          <template slot-scope="scope">
            <a v-if="getBtnPermissionsByName('编辑')" class="txt-color" @click="addContent(scope.row,false)">编辑 | </a>
            <!-- <a v-if="getBtnPermissionsByName('审核')" class="txt-color" @click="toReview(scope.row)">
                审核 |
            </a>
            <a v-if="scope.row.approveState === 'R' ||scope.row.approveState === 'Y'" class="txt-color" @click="toReview(scope.row)">
              撤回重审 |
            </a> -->
            <a v-if="getBtnPermissionsByName('删除')" class="txt-color" @click="getDeleteData(2, scope.row.guid)">删除｜</a>
            <a v-if="getBtnPermissionsByName('详情')" class="txt-color" @click="addContent(scope.row,true)">详情 </a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination class="pt pb back-color-fff content-pagination-box" background @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :page-sizes="[10,20,50, 100, 200]" :current-page="searchData.pageIndex"
      :page-size="searchData.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="searchData.totalRows">
    </el-pagination>
  </div>
</template>

<script>
import btnPermisson from '../mixins/btnPermisson';
import provinceData from '../../assets/js/cityList';
export default {
  mixins:[btnPermisson],
  data() {
    return {
      showMore: false, // 筛选项显示更多，默认否，最多显示三个
      tableHeight: window.innerHeight - 274,
      contentMainHeight:window.innerHeight - 200,
      fullscreenLoading: false,
      timeRange: '',
      updateTime: [], // 更新时间
      approveTime: [], // 审核时间
      searchData: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        clientName: '',
        clientType: '11',//客户类型 1=>10商业公司 2=>11居间人 15药店联系人
        coverageArea: '',
        customerName: '',
        productName: '',
        createUserName: '',
        createUserMobile: '',
        sendTenantGuid: localStorage.guid,
        // updateStartTime: '',//更新时间
        // updateEndTime: '',
        // updateName:'',//更新人
        // approveStartTime: '',// 审核时间
        // approveEndTime: '',
        // approveState:'',//审核状态
        bizStateList:['Y','S'],//启用状态
      },
      tableLoading: false,
      productSelectLoading: false,
      height: window.innerHeight - 260,
      right: 'right',
      tableData: [],
      technicalTitlesList: [],
      multipleSelection: [],
      productList: [],
      cityList: [],
      options: provinceData,
      companyList: [],
      approveStateOp: [
        {
          text: '待审核',
          value: 'A',
        },
        {
          text: '已通过',
          value: 'Y',
        },
        {
          text: '已驳回',
          value: 'R',
        },
      ],
      approveStateObj: {
        A: '待审核',
        Y: '已通过',
        R: '已驳回',
        N: '初始',
      },
      bizStateOp: [
       
        {
          value: "S",
          text: "停用",
        },
        {
          value: "Y",
          text: "启用",
        },
      ],
      bizStateObj: {
        S: '停用',
        Y: '启用',
      },
      type: {
        A: 'warning',
        Y: 'success',
        R: 'danger',
        N: 'info',
        S: 'danger',
      },
    };
  },
  watch: {  
    showMore(val, oldVal) {
      if (val) {
        this.tableHeight = window.innerHeight - 374;
        this.contentMainHeight = window.innerHeight - 300;
        return;
      }
      if (!val) {
        this.tableHeight = window.innerHeight - 274;
        this.contentMainHeight = window.innerHeight - 200;
        return;
      }
    },
  },
  created() {
    // if(sessionStorage.businessPageIndex&&sessionStorage.businessBack){
    //   this.searchData.pageIndex = Number(sessionStorage.businessPageIndex);
    // }
    // this.getList();
    this.getFormConfig();
    this.getProduct();
    this.getCompany();
    //按钮权限
    this.getMenuList();
  },
  activated() {
    this.getList();
  },
  methods: {
   
    getFormConfig() {
      let Userinfo = JSON.parse(localStorage.userInfo);
      this.api.get(
        `/${serverConfig.msConfigureService}/function/func/get-by-code?functionCode=TXL`
      ).then((resp) => {
        if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let data = resp.data.data;
          if (data && data.fieldList) {
            data.fieldList.filter(i => {
              return (i.appSideType == '0' || i.appSideType == '1') && i.showPosition.indexOf('1') > -1;
            })
            localStorage.setItem('TXL_CONFIG', JSON.stringify(data))
          }
          if (!resp.data.data) {
            localStorage.removeItem('TXL_CONFIG')
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    batchImport(guid) {
      this.$router.push({ path: '/importNewManagementList', query: { productGuid: this.$route.query.productGuid,type:'0024' } });
    },
    getFieldName(name, val) {
      let fieldName = '-';
      let list = this.getFieldConfig(name, 'selectItemList')
      if (list && list.length > 0) {
        list.forEach(i => {
          if (val == i.value) {
            fieldName = i.text;
          }
        })
      }
      return fieldName
    },
    getFieldConfig(params, key) {
      var fieldList = localStorage.getItem("TXL_CONFIG") && JSON.parse(localStorage.getItem("TXL_CONFIG")).fieldList;
      var newConfig = {};
      if (fieldList && fieldList.length > 0) {
        fieldList.forEach((item) => {
          if (item.fieldName == params) {
            newConfig = item;
          }
        });
      }

      return newConfig && newConfig[key];
    },
    //获取公司
    getCompany() {
      let self = this;
      let query = {
        isService: true,
        tenantGuid: localStorage.guid,
      };
      self.api
        .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.companyList = res.data.data || [];
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    selectFocus() {
      if (!this.searchData.tenantGuid) {
        this.$message.error('请先选择所属企业');
      }
    },
    companyChange(val) {
      if (!val) {
        this.searchData.franchiseeName = '';
      } else {
        this.getProduct();
      }
    },
    //获取产品
    getProduct(val) {
      let self = this;
      if (!this.searchData.tenantGuid) {
        // this.$message.error('请先选择所属企业');
        return
      }
      // this.productSelectLoading = true;
      let userInfo = JSON.parse(localStorage.userInfo)
      let obj = {
        pageIndex: 1,
        pageSize: 30,
        tenantGuid: this.searchData.tenantGuid,
        goodsName: val,
      }
      self.api.postJson(`/${serverConfig.msProductService}/goods/data/get`, obj
      ).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          // this.productSelectLoading = false;
          this.productList = res.data.data.records || [];
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    incres(area) {
      if (area && area.length > 0) {
        this.searchData.coverageArea = area[1];
      }
    },
    getList() {
      let self = this;
      // this.searchData.updateStartTime = this.updateTime[0]
      //   ? this.$moment(this.updateTime[0]).format('YYYY-MM-DD 00:00:00')
      //   : '';
      // this.searchData.updateEndTime = this.updateTime[1]
      //   ? this.$moment(this.updateTime[1]).format('YYYY-MM-DD 23:59:59')
      //   : '';
      // this.searchData.approveStartTime = this.approveTime[0]
      //   ? this.$moment(this.approveTime[0]).format('YYYY-MM-DD 00:00:00')
      //   : '';
      // this.searchData.approveEndTime = this.approveTime[1]
      //   ? this.$moment(this.approveTime[1]).format('YYYY-MM-DD 23:59:59')
      //   : '';
      if(!this.searchData.bizStateList.length){
        this.searchData.bizStateList=['Y','S']
      }
      if(self.multipleSelection && self.multipleSelection.length > 0){
        self.$refs.multipleTable.clearSelection();
      }
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msPersonnelService}/address-list/data/pc-list`, this.searchData).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records || [];
          self.searchData.totalPage = res.data.data.totalPages;
          self.searchData.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    emptySearch() {
      this.searchData = {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        clientName: '',
        clientType: '11',//客户类型 1=>10商业公司 2=>11居间人 15药店联系人
        coverageArea: '',
        customerName: '',
        productName: '',
        createUserName: '',
        createUserMobile: '',
        sendTenantGuid: localStorage.guid,
        // updateStartTime: '',//更新时间
        // updateEndTime: '',
        // updateName:'',//更新人
        // approveStartTime: '',// 审核时间
        // approveEndTime: '',
        // approveState:'',//审核状态
        bizStateList:['Y','S'],//启用状态
      };
      this.cityList = [];
      this.getList();
    },
    addContent(row,disabled) {
      if (!localStorage.getItem('TXL_CONFIG')) {
        this.$message.error('功能界面内容未配置，请联系运营人员处理')
        return
      }
      sessionStorage.removeItem('intermediaryBack')
      if (row) {
        // sessionStorage.setItem('businessPageIndex',this.searchData.pageIndex)
        this.$router.push({
          path: '/intermediaryAdd',
          query: {
            guid: row.guid,
            tenantGuid: this.searchData.tenantGuid,
            productGuid: this.$route.query.productGuid,
            disabled
          }
        })
      } else {
        // sessionStorage.removeItem('businessPageIndex')
        this.$router.push('/intermediaryAdd?productGuid=' + this.$route.query.productGuid)
      }
    },
    getChargeCustomerName(list, type) {
      let name = ''
      if (list && list.length > 0) {
        list.forEach((i, index) => {
          if (type == 1) {
            name = name + i.productName + (index + 1 == list.length ? '' : '、')
          } else if (type == 2) {
            name = name + i.cityName + (index + 1 == list.length ? '' : '、')
          } else {
            name = name + i.customerName + (index + 1 == list.length ? '' : '、')
          }
        })
      }
      return name || '-'
    },
    //专长领域
    getExpertDomainName(list) {
      if (list && list.length > 0) {
        return list[0].expertCustomerType + '/' + list[0].expertCustomerName
      } else {
        return '-'
      }

    },
     // 去审核
     toReview(item) {
      this.$router.push({
        path: `/intermediaryAudit`,
        query: {
          guid: item.guid,
          tenantGuid: this.searchData.tenantGuid,
          productGuid: this.$route.query.productGuid,

        },
      });
    },
    report() {
      let self = this;
      let req = JSON.parse(JSON.stringify(this.searchData));
      req.pageSize = -1;
      self.api.postJsonD(`/${serverConfig.msPersonnelService}/address-list/export`, req)
        .then(res => {
          let blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
          let fileName = '居间人客户资料';
          let objectUrl = URL.createObjectURL(blob);
          const link = document.createElement('a')
          link.download = fileName;
          link.href = objectUrl;
          link.click();
          self.fullscreenLoading = false;
        });
      // self.empty();
    },
    handleSizeChange(val) {
      let self = this;
      self.searchData.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.searchData.pageIndex = val;
      this.getList();
    },
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = [];
      val.forEach(function (item) {
        //item 就是当日按循环到的对象
        self.multipleSelection.push(item.guid);
      });
    },

    getDeleteData(flg, guid) {
      let self = this;
      if (flg == 1) {
        if (self.multipleSelection.length == 0) {
          self.$message.error('请勾选数据！');
          return;
        }
      } else {
        self.multipleSelection = [];
        self.multipleSelection.push(guid);
      }
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          self.api.postJson(`/${serverConfig.msPersonnelService}/address-list/data/pc-delete`, self.multipleSelection).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.multipleSelection = [];
              self.$message.success('删除成功');
              self.getList(1);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    //批量停用、启用
    batchChangeState(flg) {
      // flg为停用(s)启用(Y)状态
      let str=''
      let tips=''
      let self = this;
      if (!this.multipleSelection.length) {
        this.$message.error("请勾选数据！");
        return;
      }
      if(flg==='S'){
        str='停用后，客户信息将不被服务人员看到，确定操作吗？'
        tips='批量停用成功'
      }else{
        str='启用后，负责该客户的服务人员将可以看到此信息，确定操作吗？'
        tips='批量启用成功'
      }
      
      this.$confirm(str, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(()=>{
        self.api
            .put(
              `/${serverConfig.msPersonnelService}/address-list/update-biz-state?bizState=${flg}`,
              self.multipleSelection
            )
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.$message.success(tips);
                self.$refs.multipleTable.clearSelection();
                self.getList();
              } else {
                self.$message.error(res.data.msg);
              }
            });
      })
    },
  },
};
</script> 
<style scoped>
/deep/ .el-table-column--selection .cell{
  padding-right:10px
}
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}

.el-range-editor.el-input__inner {
  padding: 0px;
}

.doctorInformation /deep/ .el-checkbox__label {
  display: none;
}

.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}

.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}

.doctorInformation /deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}

.doctorInformation /deep/ .el-step__icon-inner {
  color: #4fa1a4;
}

.doctorInformation /deep/ .el-step__title.is-process {
  color: #4fa1a4;
}

.doctorInformation /deep/ .el-form-item__label {
  text-align: right;
}

.doctorInformation /deep/ .el-select {
  width: 100%;
}

/* .doctorInformation .search-area {
  padding-bottom: 0;
  margin-bottom: 10px;
} */

.doctorInformation /deep/ .el-col-8 {
  height: 62px;
}
.search-area-div{
  flex-shrink: 0;
  margin-right: 4px;
  width:72px;
  text-align:right
}
.ipt-sty{
  flex: 1;
}
.el-col-6{
  display: flex;
  justify-content: flex-end;
}
</style>
